module.exports = __webpack_public_path__ + "media/question2_en.816eeccd.wav";